// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2aTYi","left":"StickyBox_left__1wVvy","right":"StickyBox_right__pSEWl"};